import { useContext, useEffect, useState } from "react";
import { Select, Dropdown, Popover, Input, Checkbox } from "antd";
import { UserOutlined } from "@ant-design/icons";
import AppContext from "../../Context/AppContext";
const { Option } = Select;

const UserFilterSelect = ({setAssingedToMe, setUnderSupervision, setSelctedUsersForFilter}) => {
  const AppData = useContext(AppContext);
  const { state } = AppData || {};
  const allUsers = [...state.AllAppUsers]
  const ZUID = localStorage.getItem("ZUID");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleSelectChange = (value) => { 
    setSelectedOptions(value);
    setAssingedToMe(value.includes("assign"));
    setUnderSupervision(value.includes("supervision"));
    setSelctedUsersForFilter(value.filter(v => v !== "assign" && v !== "supervision"));
  };

  const fixedOptions = [
    { value: "assign", label: "Assigned To Me" },
    { value: "supervision", label: "Under My Supervision" },
  ];
  

  const dynamicOptions = allUsers
    .filter(user => user.zuid !== ZUID) // exclude current user
    .map(user => ({
      value: user.zuid,
      label: user.full_name,
    }));
    
  const content = (
    <div style={{ width: 250}}>
      <Select
        mode="multiple"
        value={selectedOptions}
        onChange={handleSelectChange}
        style={{ width: "100%" }}
        placeholder="Please select filter"
        optionLabelProp="label"
        showSearch
        optionFilterProp="label"
        open={true}
        dropdownStyle={{
          maxHeight: 180,
          overflowY: "auto"
        }}
        getPopupContainer={triggerNode => triggerNode.parentNode}
        showArrow={false}
      >
        {/* Fixed options always first */}
        {fixedOptions.map((opt) => (
          <Option key={opt.value} value={opt.value} label={opt.label}>
            {opt.label}
          </Option>
        ))}

        {/* Dynamic options */}
        {dynamicOptions.map((opt) => (
          <Option key={opt.value} value={opt.value} label={opt.label}>
            {opt.label}
          </Option>
        ))}
      </Select>
    </div>
  );

    return (
    <Dropdown overlay={content} trigger={["click"]}>
      <div className="user-filter-icon" style={{position: 'relative'}}>
        <UserOutlined style={{ fontSize: 14, color : '#8a8a8a' }} />
      </div>
    </Dropdown>
  );

}

export default UserFilterSelect;
